import { render, staticRenderFns } from "./Erbjudande.vue?vue&type=template&id=b9efcb2e&"
import script from "./Erbjudande.vue?vue&type=script&lang=js&"
export * from "./Erbjudande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports